import { create } from 'zustand';

interface UserGuideStore {
  isUserGuideOpen: boolean;
  setOpenUserGuide: (v: boolean) => void;
  isTourOpen: boolean;
  tourStartStep: number;
  startTour: (step: number) => void;
  closeTour: () => void;
  isCloseConfirmOpen: boolean;
  openCloseConfirm: () => void;
  closeCloseConfirm: () => void;
  confirmClose: () => void;
  isTourProfileDropdownOpen: boolean;
  setTourProfileDropdownOpen: (v: boolean) => void;
  tourCurrentIndex: number;
  setTourCurrentIndex: (v: number) => void;
}

export const useUserGuideStore = create<UserGuideStore>((set) => ({
  isUserGuideOpen: false,
  setOpenUserGuide: (v) => set({ isUserGuideOpen: v }),
  isTourOpen: false,
  tourStartStep: 0,
  startTour: (step) => set({ isTourOpen: true, tourStartStep: step, isUserGuideOpen: false }),
  closeTour: () => set({ isTourOpen: false, isTourProfileDropdownOpen: false }),
  isCloseConfirmOpen: false,
  openCloseConfirm: () => set({ isCloseConfirmOpen: true }),
  closeCloseConfirm: () => set({ isCloseConfirmOpen: false }),
  confirmClose: () =>
    set({ isUserGuideOpen: false, isTourOpen: false, isCloseConfirmOpen: false, isTourProfileDropdownOpen: false }),
  isTourProfileDropdownOpen: false,
  setTourProfileDropdownOpen: (v) => set({ isTourProfileDropdownOpen: v }),
  tourCurrentIndex: 0,
  setTourCurrentIndex: (v) => set({ tourCurrentIndex: v }),
}));
